import { get } from 'lodash';

$(() =>
{
    $('[data-toggle="tooltip"]').each((idx, elm) => {
        const placement = get(elm, 'dataset.placement', 'auto');
        const trigger = get(elm, 'dataset.trigger', 'hover');
        $(elm).tooltip({
            html: true,
            delay: 100,
            placement,
            trigger,
        });
    });

    $('[data-toggle="popover"]').each((idx, elm) => {
        const placement = get(elm, 'dataset.placement', 'auto left');
        const trigger = get(elm, 'dataset.trigger', ' hover');
        $(elm).popover({
            html: true,
            delay: 100,
            placement,
            trigger,
        });
    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/tooltips.js